<template>
  <div>
    <div class="container mb-5">
      <div class="row">
        <div class="col-md-12">
          <boton-atras :nombre_ruta="'informesSHaciendaConac'"/>
        </div>
        <div class="container text-center mb-3">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Proceso de Contratación de Deuda Pública</h1>
        </div>
        <select2Filtros class="mt-5" id="selectFiltroDeudaP" :data="dataAll" :placeholder1="'Año'" :placeholder2="'Opcion'" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" />
        <div class="w-100">
          <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="responseSelectComponent" />
        </div>
      </div>
      <span v-html="fecha_actualizacion"></span>
    </div>
  </div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import selectEjercicio from "../../../components/selectEjercicio.vue";
import catalogoDocumentos from "../../../components/catalogoDocumentos.vue";
import documentos from "../../../components/documentosModelo6.vue";
import tabla from "../../../components/tableModelo6.vue";
import botonAtras from '../../button-atras'
import FinanzasPublicas from "@/services/rendicionDeCuentas/informeFinanzaPub/informeFinanzaPub.js"
const finanzasPublicas_Service = new FinanzasPublicas();
import select2Filtros from '@/components/selectCompuesto2.vue'
import tablaSimple from '@/components/tablaSimple.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";


export default {
name: 'IFP-Proceso-Contratacion-Deuda-Publica',
mixins: [DateFormat],
components: {botonAtras, tabla, documentos ,catalogoDocumentos, selectEjercicio, select2Filtros, tablaSimple},
data(){
  return {
    dataAll: [],

    //variables mil
    responseSelectComponent: '',
    textoTitulo: '',
    fecha_actualizacion:''
  };
},
  async created(){
    window.scrollTo(0, 0);
    this.getProcesoAll();
  },
  methods:{
    async getProcesoAll(){
        try {
          const response = await finanzasPublicas_Service.getProcesoDeudaPublica(mapFun.procesoContratacionDeudaPublica);
          let fecha_texto = response[0].fecha_actualizacion;
          this.fecha_actualizacion = this.DateFormatText(fecha_texto);
          this.dataAll = response[0].contenido.reverse();
          this.dataAll = this.dataAll.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    fecha_actualizacion: e.fecha_actualizacion,
                    seccion:  e.secciones
                };
              });
        } catch (error) {
            console.log("error vista", error.message);
        }
    },
  },
watch: {
  responseSelectComponent(){
    if(this.responseSelectComponent){
      let fecha_texto = this.responseSelectComponent.fecha_actualizacion;
      this.fecha_actualizacion = this.DateFormatText(fecha_texto);
    } else{
      this.fecha_actualizacion = '';
    }
  }
},
}
</script>
